var map = {
	"./close-btn.webp": 1935,
	"./icon-caution.webp": 1936,
	"./icon-checked.webp": 1937,
	"./icon-contact-us.webp": 1938,
	"./icon-email.webp": 1939,
	"./icon-eye-close.webp": 1940,
	"./icon-eye-open.webp": 1941,
	"./icon-forget-phone.webp": 1942,
	"./icon-forget-whatsapp.webp": 1943,
	"./icon-google.webp": 1944,
	"./icon-login-email.webp": 1945,
	"./icon-password.webp": 1946,
	"./icon-robot-select.webp": 1947,
	"./icon-robot-unselect.webp": 1948,
	"./icon-telegram.webp": 1949,
	"./icon-user.webp": 1950,
	"./login-bg.webp": 1951,
	"./reglogin-bg-cn.webp": 1952,
	"./reglogin-bg-id.webp": 1953,
	"./reglogin-bg-ms.webp": 1954,
	"./reglogin-bg.webp": 1955,
	"./reglogin-m-bg-cn.webp": 1956,
	"./reglogin-m-bg-id.webp": 1957,
	"./reglogin-m-bg-ms.webp": 1958,
	"./reglogin-m-bg.webp": 1959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;